// extracted by mini-css-extract-plugin
module.exports = {"top_info":"index_top_info_3Ecdy","top_left":"index_top_left_1NWmG","top_title":"index_top_title_1fFF4","top_cont":"index_top_cont_1U6a6"};